import { render, staticRenderFns } from "./SpacingBetween.vue?vue&type=template&id=3e5f472b&"
import script from "./SpacingBetween.vue?vue&type=script&lang=js&"
export * from "./SpacingBetween.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports